'use client'

import {useUser} from '@/src/store/user-store'
import WatchlistGuestView from './guestView'
import Watchlist from './loginView'

export default function WatchlistPage() {

  const {user} = useUser()

  if(!user){
    return (<>
      <WatchlistGuestView/>
    </>)
  }

  return (<><Watchlist/></>)
  
}